module.exports = __webpack_public_path__ + "img/info_pic.6113ac58.png";